import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const navigation = [{
    name: 'Home',
    id: 'home'
  }, {
    name: 'Leistungen',
    id: 'services'
  }, {
    name: 'Prozess',
    id: 'process'
  }, {
    name: 'ESG & Impact',
    id: 'esg'
  }, {
    name: 'Branchen',
    id: 'industries'
  }, {
    name: 'Über FJT',
    id: 'about'
  }, {
    name: 'Kontakt',
    id: 'contact'
  }];
  return <footer className="w-full bg-[#0A122A] text-white" data-id="element-7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12" data-id="element-9">
          {/* Logo Section */}
          <div className="lg:col-span-4" data-id="element-10">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xdr61HSpUjGGYUGaLtPvn6/ForesightJounresTech_Logo_whtie.png" alt="Foresight Journey Technologies" className="h-14 mb-6" data-id="element-11" />
            <p className="text-gray-400 leading-relaxed" data-id="element-12">
              Die Brücke zwischen Chinas Geschwindigkeit und Europas
              Marktanforderungen.
            </p>
          </div>
          {/* Navigation */}
          <div className="lg:col-span-4" data-id="element-13">
            <h3 className="text-lg font-bold mb-6" data-id="element-14">Navigation</h3>
            <nav className="grid grid-cols-2 gap-3" data-id="element-15">
              {navigation.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-gray-400 hover:text-white transition-colors text-left" data-id="element-16">
                  {item.name}
                </button>)}
            </nav>
          </div>
          {/* Contact Info */}
          <div className="lg:col-span-4" data-id="element-17">
            <h3 className="text-lg font-bold mb-6" data-id="element-18">Kontakt</h3>
            <div className="space-y-4" data-id="element-19">
              <div className="flex items-start gap-3" data-id="element-20">
                <MapPinIcon size={20} className="text-[#0B5FFF] flex-shrink-0 mt-1" data-id="element-21" />
                <div className="text-gray-400" data-id="element-22">
                  <p data-id="element-23">Hamburg, Deutschland</p>
                  <p data-id="element-24">China</p>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-25">
                <MailIcon size={20} className="text-[#0B5FFF] flex-shrink-0" data-id="element-26" />
                <a href="mailto:info@fj-technologies.com" className="text-gray-400 hover:text-white transition-colors" data-id="element-27">
                  info@fj-technologies.com
                </a>
              </div>
              <div className="flex items-center gap-3" data-id="element-28">
                <PhoneIcon size={20} className="text-[#0B5FFF] flex-shrink-0" data-id="element-29" />
                <a href="tel:+4940607768555" className="text-gray-400 hover:text-white transition-colors" data-id="element-30">
                  +49 (0) 40 60 77 685 55
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800" data-id="element-31">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-32">
            <p className="text-gray-400 text-sm" data-id="element-33">
              © {new Date().getFullYear()} Foresight Journey Technologies. Alle
              Rechte vorbehalten.
            </p>
            <div className="flex gap-6 text-sm" data-id="element-34">
              <a href="https://pezula.ai/data-privacy/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-35">
                Datenschutz
              </a>
              <a href="https://pezula.ai/imprint/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-36">
                Impressum
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}